/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";
import { useSelector } from "store";

import type { AddressInfo } from "../../../modules/auth";

export const StreamingLiveCommerceAddressV2: React.FC = () => {
  //TODO: APIが完成したらそこから取得するように変更
  const addressInfo: AddressInfo = {
    zipCode: "123-4567",
    prefecture: "東京都",
    city: "渋谷区",
    streetNum: "1-2-3",
    buildingInfo: "渋谷ビル101",
    userName: "山田太郎",
    phone: "090-1234-5678",
  };

  const isDarkModeEnabled = useSelector(
    (state) => state.streaming.streamingSettings.isDarkModeEnabled
  );

  const isAddressRegistered = useSelector(
    (state) => state.auth.isAddressRegistered
  );

  const { t } = useI18n();

  const classesLiveCommerceAddressDesign = liveCommerceAddressDesign({
    isDarkModeEnabled,
  });
  return (
    <React.Fragment>
      <p css={classesLiveCommerceAddressDesign.addressLabel}>
        {t("streaming.commerceCart.address")}
      </p>
      <div css={classesLiveCommerceAddressDesign.address}>
        {isAddressRegistered ? (
          <React.Fragment>
            <div css={classesLiveCommerceAddressDesign.infoWrapper}>
              <p css={classesLiveCommerceAddressDesign.userName}>
                {addressInfo.userName}
              </p>
              <p css={classesLiveCommerceAddressDesign.addressDetails}>
                {addressInfo.zipCode}
                {addressInfo.prefecture}
                {addressInfo.city}
                {addressInfo.streetNum}
                {addressInfo.buildingInfo && ` ${addressInfo.buildingInfo}`}
              </p>
            </div>
            <div css={classesLiveCommerceAddressDesign.actionWrapper}>
              <div css={classesLiveCommerceAddressDesign.editButton}>
                {t("streaming.commerceCart.edit")}
              </div>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <p
              css={classesLiveCommerceAddressDesign.nonRegisteredAddressMessage}
            >
              {t("streaming.commerceCart.emptyAddressMessage")}
            </p>
            <div css={classesLiveCommerceAddressDesign.actionWrapper} />
            <p css={classesLiveCommerceAddressDesign.editButton}>
              {t("streaming.commerceCart.register")}
            </p>
            <div css={classesLiveCommerceAddressDesign.actionWrapper} />
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

type LiveCommerceAddressDesignProps = {
  isDarkModeEnabled: boolean;
};

const liveCommerceAddressDesign = (props: LiveCommerceAddressDesignProps) => {
  const { isDarkModeEnabled } = props;
  const textColorInDarkMode = isDarkModeEnabled
    ? `
      color: #FFFFFF;
    `
    : `
      color: #000000;
    `;
  const addressLabel = css`
    margin-bottom: 8px;
    ${textColorInDarkMode}
    font-size: 14px;
  `;
  const address = css`
    ${textColorInDarkMode}
    background-color: ${props?.isDarkModeEnabled ? "#333333" : "#f5f5f5"};
    display: flex;
    min-height: 104px;
    padding: 0 16px;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;
  `;
  const nonRegisteredAddressMessage = css`
    color: #ff0000;
  `;
  // 左側のテキストエリア
  const infoWrapper = css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  `;
  // ユーザー名（上部に配置）
  const userName = css`
    font-weight: bold;
    font-size: 14px;
    margin: 0;
    margin-bottom: 4px;
  `;
  const addressDetails = css`
    font-size: 14px;
    margin: 0;
    line-height: 1.5;
  `;
  // 右側の変更ボタンエリア
  const actionWrapper = css`
    flex-shrink: 0;
  `;
  const editButton = css`
    cursor: pointer;
    font-size: 14px;
  `;
  return {
    addressLabel,
    address,
    nonRegisteredAddressMessage,
    infoWrapper,
    userName,
    addressDetails,
    actionWrapper,
    editButton,
  };
};
